import React, { useEffect, useState } from "react";
import configData from "../appconfig/config.json";
import { useHistory } from "react-router-dom";
import helper from "../data/Helper";
import Loading from "./Loading";

const Home = (props) => {
    let history = useHistory();
    const [showLoading, setShowLoading] = useState(true);

    const toApplyCardsNew = () => {
        document.location.href = configData.URL_NAVIGATE_COB;
    }

    useEffect(() => {
        console.log('@home useEffect')
        localStorage.clear();
        
        // let mytest = '810209'
        // const dText1 = helper.encrypt(mytest);
        // const dText = helper.decrypt(dText1);
        // alert(dText1);
        // alert(dText);

        localStorage.setItem('CFN', '');
        getQueryString();
    })

    const getQueryString = () => {
        try {
            const queryString = require('query-string');
            const parsed = queryString.parse(props.location.search);
            if (parsed.p) {

                setShowLoading(false);
                const paramText = parsed.p;
                const dText = helper.decrypt(paramText);
                             
                if (dText === configData.SRC_CODE_CCFT || 
                    (dText === configData.SRC_CODE_OUTSIDERS && paramText === 'U2FsdGVkX18VhKxGI1ckpmOHvh5aVHGXwIS4lDQxpJg')
                    ) {
                    localStorage.setItem('p', dText)
                }
                //New 30th APR
                else if (dText === configData.SRC_CODE_CCFT03 || dText === configData.SRC_CODE_CCFT04 || dText === configData.SRC_CODE_CCFT05 || dText === configData.SRC_CODE_CCFT06 || dText === configData.SRC_CODE_HNW) {
                    localStorage.setItem('p', dText)
                }

                else {
                    //redirect to error screen
                    console.log('invalid url')
                    props.history.push("fundtrf/error");
                }
            }
            else {
                setShowLoading(false);
                console.log('invalid url')
                props.history.push("fundtrf/error");
            }
        } catch (ex) {
            console.log('invalid url')
            setShowLoading(false);
            props.history.push("fundtrf/error");
        }
    }


    if (showLoading) {
        return (
            <Loading />
        )
    }

    return (
        <div className="container mt-5">            
           
            <div className='outerdivsubheader'>
                <div className='row'>
                    <div className='col-12'>
                        <h2 className='welcome mb-0'>Maybank Fund Transfer Application</h2>
                    </div>
                </div>
                <div className='DynaForm DynamicFields'>
                    <div className='col-12'>
                        <p className='Dynamiccenteralign mb-0'>Maybank Fund Transfer Application</p>
                    </div>
                    <hr className="panelLine">
                    </hr>
                    <div className="panel-collapse collapse in">
                        <div className="panel-body">                           

                            <div className="row around-xs inputPair">
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <div>
                                        <p>
                                            For existing Maybank Credit Card or CreditAble Accounts
                                        </p>

                                        <button className="k-primary btnMaybank mb-3" onClick={() => {
                                            const pStr = localStorage.getItem('p');
                                            if (pStr !== null) {
                                                history.push('fundtrf/PersonalDetails')
                                            }
                                            else {
                                                history.push("fundtrf/error");
                                            }
                                        }}>APPLY HERE</button>
                                    </div>
                                    <div>
                                        <p>
                                            Don't have a Maybank Credit Card or CreditAble Account Yet?
                                        </p>
                                        <button className="btn k-secondary mb-3" onClick={toApplyCardsNew}>APPLY HERE</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}



export default Home;